import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "./post-bootstrap.css";
import axios from "axios";
import { init as initApm } from "@elastic/apm-rum";

initApm({
  serviceName: "concurso-front-public",
  serverUrl: window.ENV.SERVER,
  active: true,
  serviceVersion: "0.1.0", 
  environment: "concurso-academico",
  logLevel: "trace",
  breakdownMetrics: true,
});

// This axios interceptor is used for CAS Authentication
// It sends the token in the headers for all axios requests,
// so instead of doing
//     axios.get(url, {headers: {Authorization: window.Token}})
// we can just do
//     axios.get(url)
axios.interceptors.request.use((config) => {
  //  config.headers.Authorization = window.Token;
  return config;
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
